import { useCallback, useEffect, useState } from "react";
import { getListCompetitorCountry } from "../../services/customerCompetitor";

const useCountryCompetitor = () => {
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const [sortThaiDictionary, setSortThaiDictionary] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getListCompetitorCountry();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);

      const countriesOptions = [
        // { label: "เลือกทั้งหมด", value: "all" },
        ...objectValue.map((item) => ({
          label: item.countryNameTh,
          value: item.countryId,
        })),
      ];

      const newList = [...countriesOptions];
      newList.sort((a, b) => a.label.localeCompare(b.label, 'th'));
      setSortThaiDictionary(newList);

      setOptions(countriesOptions);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data, options, sortThaiDictionary];
};

export default useCountryCompetitor;
